function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var genButtonStyle = function genButtonStyle(token) {
  var _$concat$concat;

  var componentCls = token.componentCls,
      antCls = token.antCls,
      paddingXS = token.paddingXS,
      opacityLoading = token.opacityLoading;
  return _defineProperty({}, "".concat(componentCls, "-button"), _defineProperty({
    whiteSpace: 'nowrap'
  }, "&".concat(antCls, "-btn-group > ").concat(antCls, "-btn"), (_$concat$concat = {}, _defineProperty(_$concat$concat, "&-loading, &-loading + ".concat(antCls, "-btn"), {
    cursor: 'default',
    pointerEvents: 'none',
    opacity: opacityLoading
  }), _defineProperty(_$concat$concat, "&:last-child:not(:first-child):not(".concat(antCls, "-btn-icon-only)"), {
    paddingInline: paddingXS
  }), _$concat$concat)));
};

export default genButtonStyle;